<template>
  <div
    class="expandable"
    :class="{ 'expandable--open': isOpen }"
    :style="{ transitionDuration: `${transitionTime}ms` }"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
import { expandElement } from '@/helpers/animation'

export default {
  name: 'Expandable',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },

    transitionTime: {
      type: Number,
      default: On.TransitionTimes.normal,
    },
  },

  data() {
    return {
      heightAnimationTimeout: null,
    }
  },

  watch: {
    async isOpen() {
      if (this.heightAnimationTimeout) {
        clearTimeout(this.heightAnimationTimeout)
        this.afterHeightChange()
        await this.$nextTick()
      }
      await expandElement(this.$el, this.isOpen)
      this.$emit('height-change', this.$el.scrollHeight * (this.isOpen ? 1 : -1))

      // Not listening to transitionend event since it was never fired for the height property
      // if a children element was animated while the height transition was still running.
      this.heightAnimationTimeout = setTimeout(this.afterHeightChange, this.transitionTime)
    },
  },

  methods: {
    afterHeightChange() {
      this.heightAnimationTimeout = null
      this.$el.style.height = ''
      this.$emit('height-change-end')
    },
  },
}
</script>

<style lang="scss" scoped>
.expandable {
  position: relative;
  overflow: hidden;
  height: 0;
  transition-property: height;
  transition-timing-function: ease-in-out;
  will-change: height;

  &--open {
    height: auto;
  }
}
</style>
